import NetworkSvg from "@/public/icon/network";
import SafeSvg from "@/public/icon/safe";
import Svg5g from "@/public/icon/5g";
export interface ProductInfoItem {
  title: string;
  icon: string;
  desc: string;
}

export const productKeyMap = {
  zerotrust: 0,
  microisolate: 1,
  safebrowser: 2,
  xdr: 3,

  ipv6: 4,
  operatplatform: 5,
  threatintel: 6,
  ddi: 7,

  g5: 8,
  "5g": 8,
};

export const productInfo = [
  {
    headTitle: {
      title: "安全",
      desc1: "从发现威胁, 到响应和防护,",
      desc2: "全方位产品和服务",
      img: "/banner/banner2.png",
      mobileImg: "/mobile/banner/banner1.png",
    },
    title: "零信任ZTNA",
    href: "/product/safe/zerotrust",
    icon: "/home/product/ztna.png",
    desc: "零信任（Zero Trust）基于永不信任、持续验证的理念，通过多维度的安全管控，包括身份、设备、环境、网络和应用，为企业构建安全基石。适用于多种场景，如移动办公、5G安全、安全上云、政务安全、应用安全和物联网安全等。",
    feature: [
      {
        title: "网络隐身",
        desc: "实现完全的匿名性和隐私保护",
        icon: "/product/zerotrust/feature1.png",
      },
      {
        title: "精细化权限",
        desc: "只授予用户和设备所需最小权限",
        icon: "/product/zerotrust/feature2.png",
      },
      {
        title: "动态评估",
        desc: "对用户行为、身份和访问进行动态的评估和调整",
        icon: "/product/zerotrust/feature3.png",
      },
    ],
    sceneList: [
      { title: "远程安全办公", icon: "" },
      { title: "移动APP安全", icon: "" },
      { title: "物联网安全接入", icon: "" },
      { title: "互联网暴露面隐藏", icon: "" },
      { title: "政务国密应用", icon: "" },
      { title: "统一身份管控", icon: "" },
      { title: "替代SSL、VPN", icon: "" },
    ],
    framework: {
      icon: "/product/framework/ztna.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 1310,
    },
  },
  {
    headTitle: {
      title: "安全",
      desc1: "从发现威胁, 到响应和防护,",
      desc2: "全方位产品和服务",
      img: "/banner/banner2.png",
      mobileImg: "/mobile/banner/banner1.png",
    },
    title: "自适应微隔离",
    href: "/product/safe/microisolate",
    icon: "/home/product/microisolate.png",
    desc: "自适应微隔离可实现物理机、虚拟机、容器等内网通信的最小化隔离防御，确保细粒度的访问控制和隔离。通过通信可视化拓扑展示网络通信结构，并基于业务标签实现自适应策略控制，灵活地进行动态访问控制。",
    feature: [
      {
        title: "可视化",
        desc: "实现资产与互访流向可视化",
        icon: "/product/microisolate/feature1.png",
      },
      {
        title: "自动化",
        desc: "安全策略自适应与精细安全隔离",
        icon: "/product/microisolate/feature2.png",
      },
      {
        title: "最小化",
        desc: "最小化网络分段与隔离",
        icon: "/product/microisolate/feature3.png",
      },
    ],
    sceneList: [
      { title: "安全防护", icon: "" },
      { title: "物联网", icon: "" },
      { title: "云计算", icon: "" },
      { title: "资产安全管理", icon: "" },
    ],
    framework: {
      icon: "/product/framework/microisolate.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 1790,
    },
  },
  {
    headTitle: {
      title: "安全",
      desc1: "从发现威胁, 到响应和防护,",
      desc2: "全方位产品和服务",
      img: "/banner/banner2.png",
      mobileImg: "/mobile/banner/banner1.png",
    },
    title: "企业统一安全浏览器",
    href: "/product/safe/safebrowser",
    icon: "/home/product/safebrowser.png",
    desc: "提供企业统一安全浏览器，实现统一办公入口、业务发布、身份管理和访问控制。通过精细的权限控制，只有授权用户可以访问敏感信息，保护企业数据的安全。同时提供可调度编排的安全策略，帮助企业实现安全、便捷的办公环境。",
    feature: [
      {
        title: "统一办公入口",
        desc: "企业办公统一管理",
        icon: "/product/safebrowser/feature1.png",
      },
      {
        title: "数据安全防护",
        desc: "数据访问过程安全保护",
        icon: "/product/safebrowser/feature2.png",
      },
      {
        title: "缩减暴露面",
        desc: "应用暴露面防护",
        icon: "/product/safebrowser/feature3.png",
      },
    ],
    sceneList: [
      { title: "财务稽核", icon: "" },
      { title: "采购订单", icon: "" },
      { title: "业务办理", icon: "" },
      { title: "人力资源", icon: "" },
      /* { title: "政务办公", icon: "" }, */
    ],
    framework: {
      icon: "/product/framework/safebrowser.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 1180,
    },
  },
  {
    headTitle: {
      title: "安全",
      desc1: "从发现威胁, 到响应和防护,",
      desc2: "全方位产品和服务",
      img: "/banner/banner2.png",
      mobileImg: "/mobile/banner/banner1.png",
    },
    title: "XDR",
    href: "/product/safe/xdr",
    icon: "/home/product/xdr.png",
    desc: "XDR是未来数字安全防御的领先平台，将网络、终端等多个安全威胁检测和事件响应功能融合整合，提升安全运营的效率和效能。为企业提供强大的安全防御能力，帮助其更好地应对日益复杂的安全威胁。",
    feature: [
      {
        title: "资产数据采集与管理",
        desc: "全面了解和管理网络和终端资产，提高对安全威胁的感知和响应能力",
        icon: "/product/xdr/feature1.png",
      },
      {
        title: "事件发现与联合分析",
        desc: "自动化实时发现、分析安全事件",
        icon: "/product/xdr/feature2.png",
      },
      {
        title: "安全运营响应与协同",
        desc: "快速、准确地响应和协同处理安全事件",
        icon: "/product/xdr/feature3.png",
      },
    ],
    sceneList: [
      { title: "等保合规", icon: "" },
      { title: "威胁检测与响应", icon: "" },
      { title: "威胁情报", icon: "" },
      { title: "安全监测", icon: "" },
    ],
    framework: {
      icon: "/product/framework/xdr.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 730,
    },
  },
  {
    headTitle: {
      title: "网络",
      desc1: "为企业提供各种全连接泛在接入场景",
      desc2: "提供自动化采集监控等能力",
      img: "/banner/banner3.png",
      mobileImg: "/mobile/banner/banner8.png",
    },
    title: "IPv6下一代互联网实践",
    href: "/product/network/ipv6",
    icon: "/home/product/ipv6.png",
    desc: "基于IP地址双栈的可视化管理与规划、DHCP地址自动化分配和DNS域名安全解析能力，帮助企业和组织更好地管理和规划网络资源，提高网络的可用性、安全性和效率。",
    feature: [
      {
        title: "IP地址管理",
        desc: "全生命周期双栈IP地址可视化管理与规划",
        icon: "/product/ipv6/feature1.png",
      },
      {
        title: "自动化地址分配",
        desc: "基于身份准入控制和大规模双栈地址自动分配",
        icon: "/product/ipv6/feature2.png",
      },
      {
        title: "DNS域名解析",
        desc: "基于域名双栈安全解析和防护",
        icon: "/product/ipv6/feature3.png",
      },
    ],
    sceneList: [
      { title: "运维改造", icon: "" },
      { title: "网络改造", icon: "" },
      { title: "核心服务改造", icon: "" },
      { title: "安全改造", icon: "" },
    ],
    framework: {
      icon: "/product/framework/ipv6.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 940,
    },
  },
  {
    headTitle: {
      title: "网络",
      desc1: "为企业提供各种全连接泛在接入场景",
      desc2: "提供自动化采集监控等能力",
      img: "/banner/banner3.png",
      mobileImg: "/mobile/banner/banner8.png",
    },
    title: "自动化运营平台",
    href: "/product/network/operatplatform",
    icon: "/home/product/operatplatform.png",
    desc: "为企业提供全方位自动化工具，涵盖采集、监控、告警、审计和分析等环节，助力企业实现自动化运维，减少错误和延迟，增强系统稳定性，提升运营效率，降低运营成本（OPEX）。",
    feature: [
      {
        title: "资产发现",
        desc: "自动化资产扫描发现和可视化管理",
        icon: "/product/operatplatform/feature1.png",
      },
      {
        title: "安全巡检",
        desc: "自动化安全巡检与监测",
        icon: "/product/operatplatform/feature2.png",
      },
      {
        title: "安全隔离",
        desc: "自动化基线核查与隔离控制",
        icon: "/product/operatplatform/feature3.png",
      },
    ],
    sceneList: [
      { title: "自动化资产扫描", icon: "" },
      { title: "IT资产管", icon: "" },
      { title: "安全运维堡垒", icon: "" },
      { title: "4A统一认证", icon: "" },
      { title: "APM健康检测", icon: "" },
      { title: "自动化运维审计", icon: "" },
      { title: "黑洞一键封堵", icon: "" },
      { title: "自动化网络拓扑", icon: "" },
    ],
    framework: {
      icon: "/product/framework/operatplatform.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 1640,
    },
  },
  {
    headTitle: {
      title: "网络",
      desc1: "为企业提供各种全连接泛在接入场景",
      desc2: "提供自动化采集监控等能力",
      img: "/banner/banner3.png",
      mobileImg: "/mobile/banner/banner8.png",
    },
    title: "威胁情报",
    href: "/product/network/threatintel",
    icon: "/home/product/threatintel.png",
    desc: "为企业提供恶意数据采集与分析、实时异常活动监测、合作性情报共享、已知威胁检测与阻止、漏洞管理、攻击者行为分析、安全策略制定、事件响应支持、威胁趋势识别以及情报源评估等一系列关键功能。",
    feature: [
      {
        title: "情报采集",
        desc: "多维度情报数据采集",
        icon: "/product/threatintel/feature1.png",
      },
      {
        title: "情报分享",
        desc: "安全开放的信息共享和跨组织合作",
        icon: "/product/threatintel/feature2.png",
      },
      {
        title: "威胁检测",
        desc: "实时检测发现和响应处置",
        icon: "/product/threatintel/feature3.png",
      },
    ],
    sceneList: [
      { title: "入侵防御检测", icon: "" },
      { title: "网络情报", icon: "" },
      { title: "DNS安全", icon: "" },
      { title: "网络安全", icon: "" },
    ],
    framework: {
      icon: "/product/framework/threatintel.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 860,
    },
  },
  {
    field: "ddi",
    headTitle: {
      title: "核心网络，智慧掌控",
      desc1: "赛讯DDI系统让DNS、DHCP、IPAM管理更高效、更安全！",
      img: "/banner/banner3.png",
      mobileImg: "/mobile/banner/banner8.png",
    },
    title: "产品优势",
    desc: "简化网络配置，提升管理效率，增强安全性和可扩展性。",
    feature0: [
      {
        title: "国产信创，自主可控",
        img: "/product/ddi/feature1.png",
        descList: [
          "全栈国产化适配，支持银河麒麟、统信UOS等国产操作系统，兼容鲲鹏、飞腾等国产芯片，满足党政、金融、能源等关键领域信创要求。",
          "自主知识产权，核心技术100%自主研发，杜绝“卡脖子”风险，保障国家信息安全。",
        ],
      },
      {
        title: "全方位安全防护",
        img: "/product/ddi/feature2.png",
        descList: [
          "集成五位一体安全情报（PassiveDNS库、恶意域名库、ICP备案库、病毒沙箱库、IP信誉库），实时拦截钓鱼、勒索软件等网络威胁。",
          "支持DNS隐蔽隧道检测、外网DNS拦截，有效防御DDoS攻击、缓存投毒等安全风险。",
        ],
      },
      {
        title: "精细化IP管理",
        img: "/product/ddi/feature3.png",
        descList: [
          "IPv4/IPv6双栈智能规划，图形化IP地址管理（IPAM），支持动态分配、静态绑定、准入控制。",
          `联动交换机扫描，实时监控IP资产，实现“IP-MAC-端口-用户”全生命周期可视化管理。`,
        ],
      },
      {
        title: "一键式灾备切换",
        img: "/product/ddi/feature4.png",
        descList: [
          "基于健康监测的秒级灾备切换，保障业务连续性，故障恢复效率提升90%",
          "主备模式、SDN高可用架构，确保服务零中断。",
        ],
      },
    ],
    feature: [
      {
        title: "DNS（域名解析）",
        desc: "智能调度，秒级解析，让您的网络访问更快、更稳、更安全！",
        icon: "/product/ipv6/feature1.png",
      },
      {
        title: "DHCP（动态主机配置）",
        desc: "精准分配，灵活管控，实现终端即插即用，网络接入无忧！",
        icon: "/product/ipv6/feature2.png",
      },
      {
        title: "IPAM（IP地址管理）",
        desc: "可视化IP资产管理，动态监控，让网络运维更高效、更智能！",
        icon: "/product/ipv6/feature3.png",
      },
    ],
    edition: {
      title: "选择最适合您的DDI版本",
      desc: "功能差异可视化，升级路径清晰可预期",
      headerList: [
        {},
        {
          img: "/product/ddi/edition1.png",
          label: "专业版",
          bdColor: "#9664FF",
        },
        {
          img: "/product/ddi/edition2.png",
          label: "企业版",
          bdColor: "#4B73FF",
        },
        {
          img: "/product/ddi/edition3.png",
          label: "旗舰版",
          bdColor: "#FEDF52",
        },
        {
          img: "/product/ddi/edition4.png",
          label: "信创版",
          bdColor: "#FF9B50",
        },
      ],
      moduleList: [
        {
          module: "DNS",
          showExpand: true,
          expandIdx: 1,
          isExpanded: false,
          funcList: [
            {
              label: "性能",
              format: (s: string) => (
                <>
                  {s.split(",").map((c) => (
                    <p>
                      {c}
                      <br />
                    </p>
                  ))}
                </>
              ),
              component: "Text",
              list: [
                "DNS性能：≥5W QPS,DHCP性能：≥500LPS",
                "DNS性能：≥10W QPS,DHCP性能：≥1500LPS",
                "DNS性能：≥20W QPS,DHCP性能：≥3000LPS",
                "DNS性能：≥20W QPS,DHCP性能：≥3000LPS",
              ],
            },
            {
              label: "DNS",
              list: [true, true, true, true],
            },
            {
              label: "视图功能",
              list: [true, true, true, true],
            },
            {
              label: "权威记录管理",
              list: [true, true, true, true],
            },
            {
              label: "权威记录监控及调度",
              list: [true, true, true, true],
            },
            {
              label: "递归转发",
              list: [true, true, true, true],
            },
            {
              label: "递归转发目标服务器监控及调度",
              list: [true, true, true, true],
            },
            {
              label: "日志报表",
              list: [true, true, true, true],
            },
            {
              label: "安全控制",
              list: [true, true, true, true],
            },
            {
              label: "TTL管控",
              list: [true, true, true, true],
            },
            {
              label: "工单管理",
              list: [false, false, true, true],
            },
            {
              label: "域权限管理",
              list: [false, true, true, true],
            },
            {
              label: "威胁情报查询",
              list: [false, "可选配", "可选配", "可选配"],
            },
            {
              label: "威胁情报拦截",
              list: [false, "可选配", "可选配", "可选配"],
            },
            {
              label: "威胁情报报表",
              list: [false, "可选配", "可选配", "可选配"],
            },
          ],
        },
        {
          module: "DHCP",
          showExpand: true,
          isExpanded: false,
          expandIdx: 0,
          funcList: [
            {
              label: "DHCP",
              list: [true, true, true, true],
            },
            {
              label: "IPv4网络分配",
              list: [true, true, true, true],
            },
            {
              label: "IPv6网络分配",
              list: [true, true, true, true],
            },
            {
              label: "报表功能",
              list: [true, true, true, true],
            },
            {
              label: "IP、MAC地址绑定",
              list: [true, true, true, true],
            },
          ],
        },
        {
          module: "IPAM",
          showExpand: true,
          isExpanded: false,
          expandIdx: 0,
          funcList: [
            {
              label: "IPAM",
              list: [true, true, true, true],
            },
            {
              label: "节点管理",
              list: [true, true, true, true],
            },
            {
              label: "IPv4规划管理",
              list: [true, true, true, true],
            },
            {
              label: "IPv6规划方案",
              list: [true, true, true, true],
            },
            {
              label: "IPv6规划管理",
              list: [true, true, true, true],
            },
            {
              label: "网段扫描",
              list: [true, true, true, true],
            },
            {
              label: "MAC地址管理",
              list: [true, true, true, true],
            },
            {
              label: "报表功能 ",
              list: [true, true, true, true],
            },
            {
              label: "工单管理",
              list: [false, false, true, true],
            },
            {
              label: "平面体系",
              list: [false, true, true, true],
            },
            {
              label: "组织架构",
              list: [false, true, true, true],
            },
            {
              label: "数据权限",
              list: [false, true, true, true],
            },
          ],
        },
        {
          module: "service",
          showExpand: false,
          expandIdx: 0,
          funcList: [
            {
              label: (
                <div className="flex flex-col" style={{ marginLeft: "-12px" }}>
                  <div className="flex items-center space-x-2">
                    <div className="w-1 h-4 bg-[#0E81FF] rounded-sm"></div>
                    <span>技术服务</span>
                  </div>
                  <div style={{ paddingLeft: "12px" }} className="text-xs">
                    提供7*24小时技术支持
                  </div>
                </div>
              ),

              list: [true, true, true, true],
            },
          ],
        },
      ],
    },
  },
  {
    headTitle: {
      title: "5G",
      desc1: "构建5G网络与用户的便捷安全接入通道",
      desc2: "可快速搭建5G专用安全网络",
      img: "/banner/banner1.png",
      mobileImg: "/mobile/banner/banner2.png",
    },
    title: "5G产品能力",
    href: "/product/5g",
    icon: "/home/product/g5.png",
    desc: "赛讯提供5G场景下多维度的产品能力，包括5G安全接入CPE、MEC隔离防护、5G组网等，构建5G网络与用户的便捷安全接入通道，可快速搭建5G专用安全网络。",
    feature: [
      {
        title: "5G 无感零信任",
        desc: "",
        icon: "/product/5g/feature1.png",
      },
      {
        title: "5G MEC微隔离",
        desc: "",
        icon: "/product/5g/feature2.png",
      },
      {
        title: "5G CPE组网",
        desc: "",
        icon: "/product/5g/feature3.png",
      },
    ],
    framework: {
      icon: "/product/framework/g5.png",
      cls: "",
      mobileCls: "",
      width: 2160,
      height: 1640,
    },
    sceneList: [
      { title: "5G应用安全", icon: "/product/5g/scene1.png" },
      { title: "5GCPE组网", icon: "/product/5g/scene2.png" },
      { title: "5G通信安全", icon: "/product/5g/scene3.png" },
      { title: "5GMEC微隔离", icon: "/product/5g/scene4.png" },
      { title: "5G无感零信任", icon: "/product/5g/scene5.png" },
    ],
  },
];

export const productList = {
  safe: [...productInfo.slice(0, 4)],
  network: [...productInfo.slice(4, -1).filter((v) => v.field != "ddi")],
  g5: [...productInfo.slice(-1)],
  "5g": [...productInfo.slice(-1)],
};

export const productMenuList = [
  {
    title: "安全",
    icon: <SafeSvg className="w-6 h-6" />,
    href: "/product/safe/zerotrust",
    children: [
      { title: "零信任ZTNA", href: "/product/safe/zerotrust" },
      { title: "自适应微隔离", href: "/product/safe/microisolate" },
      { title: "企业统一安全浏览器", href: "/product/safe/safebrowser" },
      { title: "XDR", href: "/product/safe/xdr" },
      { title: "威胁情报", href: "/product/network/threatintel" },
    ],
  },
  {
    title: "网络",
    icon: <NetworkSvg className="w-6 h-6" />,
    href: "/product/network/ipv6",
    children: [
      { title: "IPv6下一代互联网实践", href: "/product/network/ipv6" },
      { title: "DDI（DNS/DHCP/IPAM）", href: "/product/network/ddi" },
      { title: "自动化运营平台", href: "/product/network/operatplatform" },
      { title: "网络AAA" },
    ],
  },
  {
    title: "5G",
    icon: <Svg5g className="w-6 h-6" />,
    href: "/product/5g",
    children: [{ title: "5G产品能力", href: "/product/5g" }],
  },
];
